module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_rekishitekikenzobutu-8decabdafa02526be333d180865d647d.jpg";